import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },
  content: {
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(3)
    },
    [theme.breakpoints.between('md', 'lg')]: {
      marginLeft: 240,
    },
  },
}));

export default function Content(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <div className={classes.content}>{props.children}</div>
        </Grid>
      </Grid>
    </div>
  );
}